// extracted by mini-css-extract-plugin
export var askRedoIcon = "_a-k";
export var askRedoTag = "_a-j";
export var askRedoText = "_a-l";
export var brandGroup = "_a-2";
export var chevron = "_a-p";
export var chevronActive = "_a-q";
export var chevronDown = "_a-f";
export var divider = "_a-r";
export var exitIcon = "_a-i";
export var exitTag = "_a-g";
export var exitText = "_a-h";
export var header = "_a-0";
export var logo = "_a-3";
export var navBar = "_a-1";
export var productIcon = "_a-5";
export var productName = "_a-6";
export var productTag = "_a-4";
export var profileAvatar = "_a-b";
export var profileGroup = "_a-a";
export var profileImage = "_a-c";
export var profileInitials = "_a-d";
export var progressFill = "_a-t";
export var progressTrack = "_a-s";
export var rightGroup = "_a-7";
export var stepLabel = "_a-n";
export var stepLabelActive = "_a-o";
export var stepLabels = "_a-m";
export var storeName = "_a-e";
export var themeIcon = "_a-9";
export var themeTag = "_a-8";